import { ProductApi } from '../../api';
import axios from '../axios';

const productApi = new ProductApi(undefined, undefined, axios);

export default productApi;
